import { get } from 'lodash';

export const getHost = (state) => get(state, `common.host`);
export const getIsApp = (state) => get(state, `common.isApp`);
